<template>
  <vue-good-table class="col-12 top-24" ref="myTable"
                  :columns="columns"
                  :rows="formattedPartnerWasteReports"
                  :pagination-options="{
            enabled: true,
            perPage: 25
        }"
                  :search-options="{
            enabled: true
        }"
  >

    <template #table-actions>
      <download-excel
          class="btn-primary"
          style="padding-top: 1px;
                       padding-bottom: 1px;
                       margin-right: 5px;
                       margin-top: 2px;"
          :data="formattedPartnerWasteReports"
          :fields="excelFields"
          worksheet="Отчет по отходам"
          :name="excelFileName"
      >
        Экспорт
      </download-excel>
    </template>
  </vue-good-table>
</template>

<script>
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { VueGoodTable } from 'vue-good-table-next';
import JsonExcel from "vue-json-excel3";

export default {
  components: { VueGoodTable, downloadExcel: JsonExcel },
  data() {
    return {
      columns: [
        // {
        //   label: 'Группа отходов',
        //   field: 'WasteGroup',
        // },
        {
          label: 'Наименование отхода',
          field: 'WasteType',
        },
        {
          label: 'Код по ФККО',
          field: 'FKKOCode',
        },
        {
          label: 'Контрагент',
          field: 'CompanyName',
        },
        {
          label: 'ИНН Контрагента',
          field: 'CompanyINN',
          type: 'string'
        },
        {
          label: '№ договора',
          field: 'ContractName',
        },
        {
          label: 'Принято на объект, всего тонн',
          field: 'WholeWeight',
          type: 'number',
          formatFn: this.formatNumberDisplay
        },
        {
          label: 'Направлено на утилизацию (м3)',
          field: 'RecyclingVolume',
          type: 'number',
          formatFn: this.formatNumberDisplay
        },
        {
          label: 'Направлено на утилизацию (тонн)',
          field: 'RecyclingWeight',
          type: 'number',
          formatFn: this.formatNumberDisplay
        },
        {
          label: 'Направлено на захоронение (м3)',
          field: 'DumpingVolume',
          type: 'number',
          formatFn: this.formatNumberDisplay
        },
        {
          label: 'Направлено на захоронение (тонн)',
          field: 'DumpingWeight',
          type: 'number',
          formatFn: this.formatNumberDisplay
        },
      ],
      excelFields: {
        // 'Группа отходов': 'WasteGroup',
        'Наименование отхода': 'WasteType',
        'Код по ФККО': 'FKKOCode',
        'Контрагент': 'CompanyName',
        'ИНН Контрагента': 'CompanyINN',
        '№ договора': 'ContractName',
        'Принято на объект, всего тонн': 'WholeWeightExport',
        'Направлено на утилизацию (м3)': 'RecyclingVolumeExport',
        'Направлено на утилизацию (тонн)': 'RecyclingWeightExport',
        'Направлено на захоронение (м3)': 'DumpingVolumeExport',
        'Направлено на захоронение (тонн)': 'DumpingWeightExport'
      }
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    PartnerWasteReports() {
      return this.$store.state.eco_partner_waste_reports
    },
    formattedPartnerWasteReports() {
      return this.PartnerWasteReports.map(item => ({
        ...item,
        CompanyINN: this.formatAsText(item.CompanyINN),
        WholeWeight: this.formatNumberDisplay(item.WholeWeight),
        RecyclingVolume: this.formatNumberDisplay(item.RecyclingVolume),
        RecyclingWeight: this.formatNumberDisplay(item.RecyclingWeight),
        DumpingVolume: this.formatNumberDisplay(item.DumpingVolume),
        DumpingWeight: this.formatNumberDisplay(item.DumpingWeight),
        FKKOCode: this.formatAsText(item.FKKOCode),
        WholeWeightExport: this.formatNumberWithComma(item.WholeWeight),
        RecyclingVolumeExport: this.formatNumberWithComma(item.RecyclingVolume),
        RecyclingWeightExport: this.formatNumberWithComma(item.RecyclingWeight),
        DumpingVolumeExport: this.formatNumberWithComma(item.DumpingVolume),
        DumpingWeightExport: this.formatNumberWithComma(item.DumpingWeight)
      }));
    },
    excelFileName() {
      const now = new Date();
      const dateStr = now.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replace(/\./g, '-');

      const timeStr = now.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).replace(/:/g, '-');

      return `отходы_отчет_${dateStr}_${timeStr}.xls`;
    }
  },
  methods: {
    formatAsText(value) {
      if (!value) return '';
      return String(value);
    },
    formatNumberDisplay(value) {
      if (value === null || value === undefined) return '0';

      const num = Number(value);
      if (isNaN(num)) return '0';
      return this.removeTrailingZeros(num.toFixed(4));
    },
    removeTrailingZeros(numberString) {
      return numberString.replace(/\.?0+$/, '');
    },

    formatNumberWithComma(value) {
      if (value === null || value === undefined) return '0';
      const num = Number(value);
      if (isNaN(num)) return '0';
      const formatted = num.toLocaleString('ru-RU', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4
      });
      return this.removeTrailingZeros(formatted);
    }
  }
};
</script>